import styled from 'styled-components';
import { BsInfoCircle } from 'react-icons/bs';

export const MyInfoCircle = styled(BsInfoCircle)`
  transform: translateY(20%);
  margin-left: 5px;
  color: #19aaee;
  cursor: pointer;
`;
